import {
  Card,
  Row,
  Col,
  Space,
  Select,
  InputNumber,
  Button,
  Divider,
  Alert,
  Tooltip,
  Slider,
  Input,
  message,
  Form,
} from "antd";
import StatusDropdown from "./StatusDropDown";
import {
  egyptCities,
  majorOptions,
  universityOptions,
} from "../data/profileOptions";
import {
  FilterOutlined,
  ClearOutlined,
  SearchOutlined,
  UpOutlined,
  DownOutlined,
  CheckSquareOutlined,
  DownloadOutlined,
  MailOutlined,
  UserAddOutlined,
  CloseOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import Title from "antd/es/skeleton/Title";
import MatchingCount from "./MatchingCount";

const { Option } = Select;
export function RoundScoresToolbar({
  formName,
  gradYears,
  judges,
  threshold,
  setThreshold,
  handleGradYearFilter,
  handleStatusFilter,
  handleThresholdFilter,
  handleJudgeFilter,
  selectedBulkStatus,
  setSelectedBulkStatus,
  handleApplyStatusToSelected,
  handleApplyStatusToFiltered,
  handleApplyJudgeToFiltered,
  handleExport,
  handleExportEmails,
  handleGenderFilter,
  handleDisabilityFilter,
  handleUniversityFilter,
  handleMajorFilter,
  handleCityFilter,
  matchingCount,
  filters,
  loadScores,
  handleAssignAllSelected,
  exportLoading,
  handleClear,
  handleClearExceptStatus,
  handleEmailFilter,
  handlePhoneFilter,
  emailFilter,
  phoneFilter,
  loadContactScores,
  batchSize,
  setBatchSize,
  appendEmail,
  setAppendEmail,
  matchingCountLoading,
}) {
  const [academicExpanded, setAcademicExpanded] = useState(false);
  const [contactExpanded, setContactExpanded] = useState(false);
  const [evaluationExpanded, setEvaluationExpanded] = useState(false);
  const [demographicsExpanded, setDemographicsExpanded] = useState(false);
  const [judgeEmail, setJudgeEmail] = useState("");

  const batchOptions = [10, 25, 50, 75, 100, 150, 200, 300, 500, 750, 1000];

  const onBatchChange = (value) => {
    setBatchSize(value);
  };

  const onExportEmails = () => {
    handleExportEmails(batchSize);
  };

  return (
    <>
      {/* ─────────────── Filters ─────────────── */}
      <Card
        style={{ marginBottom: 20 }}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FilterOutlined style={{ fontSize: 16, color: "#1890ff" }} />
            <span style={{ fontSize: 16, fontWeight: 600 }}>
              Filter Submissions
            </span>
          </div>
        }
        extra={
          <Space size="middle" align="center">
            <MatchingCount
              matchingCount={matchingCount}
              matchingCountLoading={matchingCountLoading}
            />
            <Button
              type="primary"
              onClick={() => loadScores()}
              icon={<SearchOutlined />}
              style={{ minWidth: 120, height: "32px" }}
            >
              Apply Filters
            </Button>
            <Button
              icon={<ClearOutlined />}
              style={{ minWidth: 100, height: "32px" }}
              onClick={() => handleClear()}
            >
              Clear All
            </Button>
          </Space>
        }
        bodyStyle={{ padding: "20px 24px" }}
      >
        {/* Contact Search Section */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#666",
              marginBottom: 12,
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: 8,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setContactExpanded(!contactExpanded)}
          >
            <span>🔍 Search by Contact Info</span>
            <Button
              type="text"
              size="small"
              icon={contactExpanded ? <UpOutlined /> : <DownOutlined />}
              style={{
                fontSize: "12px",
                color: "#1890ff",
                padding: "0 4px",
                height: "20px",
              }}
            >
              {contactExpanded ? "Less" : "More"}
            </Button>
          </div>

          {contactExpanded && (
            <Row gutter={[20, 16]}>
              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Email
                  </label>
                </div>
                <Input
                  placeholder="Enter exact email"
                  value={emailFilter}
                  onChange={(e) => handleEmailFilter(e.target.value)}
                  onBlur={() => {
                    const email = emailFilter;
                    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                    if (email && !isValid) {
                      message.error("Please enter a valid email address.");
                    }
                  }}
                  disabled={threshold > 0}
                />
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Mobile Phone
                  </label>
                </div>
                <Input
                  placeholder="Enter exact mobile number"
                  value={phoneFilter}
                  onChange={(e) => handlePhoneFilter(e.target.value)}
                  onBlur={() => {
                    const phone = phoneFilter;
                    const isValid = /^\+?[0-9]{7,15}$/.test(phone);
                    if (phone && !isValid) {
                      message.error(
                        "Enter a valid phone number (7–15 digits)."
                      );
                    }
                  }}
                  disabled={threshold > 0}
                />
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6, visibility: "hidden" }}>
                  Trigger
                </div>
                <Button
                  type="primary"
                  block
                  onClick={loadContactScores}
                  disabled={
                    (!emailFilter && !phoneFilter) ||
                    (emailFilter &&
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailFilter)) ||
                    (phoneFilter && !/^\+?[0-9]{7,15}$/.test(phoneFilter))
                  }
                >
                  🔍 Search
                </Button>
              </Col>
            </Row>
          )}
        </div>

        {/* Academic Information Section */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#666",
              marginBottom: 12,
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: 8,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setAcademicExpanded(!academicExpanded)}
          >
            <span>📚 Academic Information</span>
            <Button
              type="text"
              size="small"
              icon={academicExpanded ? <UpOutlined /> : <DownOutlined />}
              style={{
                fontSize: "12px",
                color: "#1890ff",
                padding: "0 4px",
                height: "20px",
              }}
            >
              {academicExpanded ? "Less" : "More"}
            </Button>
          </div>
          {academicExpanded && (
            <Row gutter={[20, 16]}>
              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Graduation Year
                  </label>
                </div>
                <Select
                  placeholder="Select graduation year"
                  allowClear
                  onChange={handleGradYearFilter}
                  value={filters.gradYearFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                >
                  {gradYears.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    University
                  </label>
                </div>
                <Select
                  placeholder="Select university"
                  allowClear
                  value={filters.universityFilter}
                  onChange={handleUniversityFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {universityOptions.map((uni) => (
                    <Option key={uni} value={uni}>
                      {uni}
                    </Option>
                  ))}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Major
                  </label>
                </div>
                <Select
                  placeholder="Select major"
                  allowClear
                  value={filters.majorFilter}
                  onChange={handleMajorFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {majorOptions.map((major) => (
                    <Option key={major} value={major}>
                      {major}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}
        </div>

        {/* Evaluation & Status Section */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#666",
              marginBottom: 12,
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: 8,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setEvaluationExpanded(!evaluationExpanded)}
          >
            <span>📋 Evaluation & Status</span>
            <Button
              type="text"
              size="small"
              icon={evaluationExpanded ? <UpOutlined /> : <DownOutlined />}
              style={{
                fontSize: "12px",
                color: "#1890ff",
                padding: "0 4px",
                height: "20px",
              }}
            >
              {evaluationExpanded ? "Less" : "More"}
            </Button>
          </div>
          {evaluationExpanded && (
            <Row gutter={[24, 20]}>
              <Col xs={24} sm={12} md={12}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{ fontSize: 14, fontWeight: 500, color: "#595959" }}
                  >
                    Application Status
                  </label>
                </div>
                <Select
                  placeholder="Filter by status"
                  allowClear={false}
                  onChange={handleStatusFilter}
                  style={{ width: "100%" }}
                  value={filters.statusFilter}
                  // Status filter remains enabled even if score is selected
                >
                  <Option value="qualified">
                    <Space>
                      <span style={{ color: "#52c41a" }}>●</span>Qualified
                    </Space>
                  </Option>
                  <Option value="disqualified">
                    <Space>
                      <span style={{ color: "#ff4d4f" }}>●</span>Disqualified
                    </Space>
                  </Option>
                  <Option value="pending">
                    <Space>
                      <span style={{ color: "#faad14" }}>●</span>Under Review
                    </Space>
                  </Option>
                  <Option value="awaiting_submission">
                    <Space>
                      <span style={{ color: "#d9d9d9" }}>●</span>Awaiting
                      Submission
                    </Space>
                  </Option>
                </Select>
              </Col>

              <Col xs={24} sm={12} md={12}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{ fontSize: 14, fontWeight: 500, color: "#595959" }}
                  >
                    Assigned Judge
                  </label>
                </div>
                <Select
                  placeholder="Select judge"
                  allowClear
                  value={filters.judgeFilter}
                  onChange={handleJudgeFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {judges.map((j) => (
                    <Option key={j.email} value={j.email}>
                      {j.name}
                    </Option>
                  ))}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={12}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{ fontSize: 14, fontWeight: 500, color: "#595959" }}
                  >
                    Minimum Score{" "}
                    <Tooltip title="Enabling this will reset other filters except status">
                      <InfoCircleOutlined
                        style={{ color: "#1890ff", fontSize: 14 }}
                      />
                    </Tooltip>
                  </label>
                </div>
                <Slider
                  min={0}
                  max={100}
                  value={threshold}
                  disabled={
                    formName != "Quiz Round" && formName != "Video Interview"
                  }
                  onChange={(value) => {
                    setThreshold(value);
                    if (value > 0) {
                      // Clear all other filters except status
                      handleClearExceptStatus();
                    }
                  }}
                  onAfterChange={(value) => handleThresholdFilter(value)}
                  marks={{ 0: "0", 25: "25", 50: "50", 75: "75", 100: "100" }}
                  tooltip={{ formatter: (value) => `${value} pts` }}
                />
              </Col>
            </Row>
          )}
        </div>

        {/* Demographics & Location Section */}
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#666",
              marginBottom: 12,
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: 8,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setDemographicsExpanded(!demographicsExpanded)}
          >
            <span>👥 Demographics & Location</span>
            <Button
              type="text"
              size="small"
              icon={demographicsExpanded ? <UpOutlined /> : <DownOutlined />}
              style={{
                fontSize: "12px",
                color: "#1890ff",
                padding: "0 4px",
                height: "20px",
              }}
            >
              {demographicsExpanded ? "Less" : "More"}
            </Button>
          </div>
          {demographicsExpanded && (
            <Row gutter={[20, 16]}>
              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Gender
                  </label>
                </div>
                <Select
                  placeholder="Select gender"
                  allowClear
                  value={filters.genderFilter}
                  onChange={handleGenderFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                >
                  <Option value="Male">Male</Option>
                  <Option value="Female">Female</Option>
                  <Option value="prefer_not_to_say">Prefer not to say</Option>
                </Select>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    Disability Status
                  </label>
                </div>
                <Select
                  placeholder="Select disability status"
                  allowClear
                  value={filters.disabilityFilter}
                  onChange={handleDisabilityFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                >
                  <Option value="true">Has Disability</Option>
                  <Option value="false">No Disability</Option>
                </Select>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 6 }}>
                  <label
                    style={{ fontSize: 13, color: "#666", fontWeight: 500 }}
                  >
                    City
                  </label>
                </div>
                <Select
                  placeholder="Select city"
                  allowClear
                  onChange={handleCityFilter}
                  value={filters.cityFilter}
                  disabled={threshold > 0}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {egyptCities.map((city) => (
                    <Option key={city} value={city}>
                      {city}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}
        </div>
      </Card>

      {/* ─────────────── Bulk Actions ─────────────── */}
      <Card size="small" title="Bulk Actions">
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          {/* Status Actions */}
          <Divider orientation="left">Status Updates</Divider>
          <Space wrap>
            <StatusDropdown
              value={selectedBulkStatus}
              onChange={setSelectedBulkStatus}
              style={{ width: 200 }}
            />
            <Button
              type="primary"
              icon={<CheckSquareOutlined />}
              disabled={!selectedBulkStatus}
              onClick={() => handleApplyStatusToSelected(selectedBulkStatus)}
            >
              Apply to Selected Rows
            </Button>
            <Button
              type="default"
              icon={<FilterOutlined />}
              disabled={!selectedBulkStatus}
              onClick={() => handleApplyStatusToFiltered(selectedBulkStatus)}
              style={{
                borderColor: "#1890ff",
                color: "#1890ff",
              }}
            >
              Apply to All Filtered
            </Button>
          </Space>

          {/* Judge Assignment Actions */}
          <Divider orientation="left">Assign Judge</Divider>
          <Space wrap>
            <Select
              placeholder="Select judge's email"
              onChange={setJudgeEmail}
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
            >
              {judges.map((judge) => (
                <Option key={judge.email} value={judge.email}>
                  {judge.email}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              icon={<UserAddOutlined />}
              onClick={() => handleAssignAllSelected()}
            >
              Assign to Selected Rows
            </Button>
            <Button
              type="default"
              icon={<UserAddOutlined />}
              // disabled={!selectedJudge}
              onClick={() => handleApplyJudgeToFiltered(judgeEmail)}
              style={{
                borderColor: "#1890ff",
                color: "#1890ff",
              }}
            >
              Assign to All Filtered
            </Button>
          </Space>

          <Divider />
          <Title level={5}>Exports</Title>

          {/* Export All Button */}
          <Col>
            <Button
              type="default"
              loading={exportLoading}
              icon={<DownloadOutlined />}
              onClick={handleExport}
            >
              Export All Data
            </Button>
          </Col>

          {/* Divider */}
          <Col>
            <span
              style={{
                borderLeft: "1px solid #ddd",
                height: 32,
                display: "inline-block",
              }}
            />
          </Col>

          {/* Batched Email Export Controls */}
          <Col>
            <Space direction="vertical" size="small">
              <Select
                value={batchSize}
                onChange={onBatchChange}
                style={{ width: 200 }}
                placeholder="Select Batch Size"
              >
                {batchOptions.map((size) => (
                  <Option key={size} value={size}>
                    {size} per batch
                  </Option>
                ))}
              </Select>

              <Form.Item
                name="appendEmail"
                rules={[
                  {
                    type: "email",
                    message: "Please enter a valid email",
                  },
                ]}
              >
                <Input
                  placeholder="Append this email to each batch (optional)"
                  value={appendEmail}
                  onChange={(e) => setAppendEmail(e.target.value)}
                  style={{ width: 300 }}
                />
              </Form.Item>

              <Button
                type="primary"
                loading={exportLoading}
                icon={<MailOutlined />}
                onClick={onExportEmails}
              >
                Export Emails for BCC ({batchSize})
              </Button>
            </Space>
          </Col>
        </Space>
      </Card>
    </>
  );
}
